import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {StatistiquesEGAlimService} from "../../../core/services/egalim/statistiques-egalim.service";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";
import {UtilsService} from "../../../core/utils/utils.service";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {MaCantineConnectionDTO} from "../../../core/dtos/egalim/ma-cantine-connection-dto";

@Component({
    selector: 'yo-ma-cantine-connection-dialog',
    templateUrl: './ma-cantine-connection-dialog.component.html',
    styleUrls: ['./ma-cantine-connection-dialog.component.scss'],
    standalone: false
})
export class MaCantineConnectionDialogComponent implements OnInit, OnDestroy {

  public displayed: boolean = false;
  public isEdited: boolean = false;
  public isReseted: boolean;

  public maCantineConnection: MaCantineConnectionDTO;

  public maCantineUri: string;
  public maCantineClientId: string;
  public maCantineClientSecret: string;

  subOpen: Subscription;
  subOnMaCantineConnection: Subscription;

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  constructor(
    private utilsSvc: UtilsService,
    private auth2Svc: Auth2Service,
    private statistiquesEgalimSvc: StatistiquesEGAlimService) {
  }

  ngOnInit(): void {
    this.initSubOpen();
    this.initSubOnMaCantineConnection();
  }

  ngOnDestroy() {
    this.utilsSvc.unsubscribe(this.subOpen);
    this.utilsSvc.unsubscribe(this.subOnMaCantineConnection);
  }

  initSubOpen = () => {
    this.subOpen = this.statistiquesEgalimSvc.openMaCantineConnectionDialog$.subscribe((maCantineConnection) => {
      this.initConnection(maCantineConnection);
      this.displayed = true;
    })
  }

  initSubOnMaCantineConnection = () => {
    this.subOnMaCantineConnection = this.statistiquesEgalimSvc.onMaCantineCredentialsUpdate$.subscribe(connection => {
      this.initConnection(connection)
    })
  }

  initConnection = (maCantineConnection) => {
    this.maCantineConnection = maCantineConnection ? {...maCantineConnection} : new MaCantineConnectionDTO();
    this.maCantineClientId = this.maCantineConnection?.clientId;
    this.maCantineUri = maCantineConnection?.maCantineUri + 'o/applications/';
    this.maCantineClientSecret = "";
    this.isReseted = !this.maCantineClientId;
    this.isEdited = false;
  }

  public save = () => {
    this.statistiquesEgalimSvc.saveMaCantineCredentials(this.maCantineClientId, this.maCantineClientSecret).subscribe(result => {
      if (result && !result.error) {
        this.statistiquesEgalimSvc.onMaCantineCredentialsUpdate(result.one);
      }
    })
  };

  public connect = () => {
    this.statistiquesEgalimSvc.initiateMaCantineConnection();
  }

  public getRedirectUri = () => {
    return `${window.location.origin}/dolrest/login/oauth2/code/MaCantine_${this.auth2Svc.utilisateur.username}`
  };

  reset() {
    this.maCantineClientId = "";
    this.maCantineClientSecret = "";
    this.isReseted = true;
  }

  onEdit = () => {
    this.isEdited = true;
  }

  onClientIdEdit($event: any) {
    this.onEdit()
    this.maCantineClientId = $event;
  }

  onClientSecretEdit($event: any) {
    this.onEdit()
    this.maCantineClientSecret = $event;
  }

  openMaCantine() {
    window.open(this.maCantineUri, '_blank').focus();
  }
}
